import * as React from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Button } from '../../core/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../core/dropdown-menu';
import { cn } from '../../../utils';

export type RowAction = {
  label: string;
  icon?: React.ReactNode;
  onSelect: () => void;
  disabled?: boolean;
  destructive?: boolean;
  hidden?: boolean;
  /** Draw a separator above this item. */
  separatorBefore?: boolean;
};

type RowActionsMenuProps = {
  items: RowAction[];
  /** Accessible name of the trigger, e.g. "Ações de Ana". */
  label: string;
  className?: string;
};

/** The "⋯" menu at the end of a row. Clicks never bubble to the row. */
export function RowActionsMenu({ items, label, className }: RowActionsMenuProps) {
  const visible = items.filter((i) => !i.hidden);
  if (visible.length === 0) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={label}
          className={cn('h-8 w-8', className)}
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {visible.map((item, index) => (
          <React.Fragment key={item.label}>
            {item.separatorBefore && index > 0 ? <DropdownMenuSeparator /> : null}
            <DropdownMenuItem
              disabled={item.disabled}
              onSelect={(e) => {
                e.stopPropagation();
                item.onSelect();
              }}
              className={cn('gap-2', item.destructive && 'text-destructive focus:text-destructive')}
            >
              {item.icon}
              {item.label}
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
